import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getMultiFactorResolver,
  PhoneMultiFactorGenerator,
  sendPasswordResetEmail,
} from 'firebase/auth';

const config = {
  apiKey: 'AIzaSyCWUzeZ7-Xf8fZCWJULHYDbc7poG4F3_ik',
  authDomain: 'enliv-342806.firebaseapp.com',
};

const firebaseApp = initializeApp(config);
const auth = getAuth(firebaseApp);

export {
  auth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getMultiFactorResolver,
  PhoneMultiFactorGenerator,
  sendPasswordResetEmail,
};
